import React from "react";

import ModalV4 from "../../../app/ui/modal/v4/v4";
import ModalAddUserMeetingUsersForm from "./add-meeting-users-form/add-meeting-users-form";

class ModalAddMeetingUser extends ModalV4 {

    state = {
        search: '',
        selected: []
    }

    constructor(props) {
        super(props);

        this.projectId = props.params.projectId;

        // precalculate potential users...
        this.existingUsers = [];
        this.projectUsers = [];
        this.companyUsers = [];
        let tempProjectUsersIds = [];

        if (props.params.users) this.existingUsers = props.params.users;

        // get all project users
        gd.session.projectUsers.filterByProject(this.projectId).map(pu=>{tempProjectUsersIds.push(pu.user.id);});

        // get all available project users
        gd.session.projectUsers.filterByProject(this.projectId, gd.const.project.access.LIMITED).map(pu=>{
            if (!this.existingUsers.includes(pu.user.id)) {
                this.projectUsers.push(pu);
            }
        });

        gd.session.companyUsers.filterByCompanyAndRoles(gd.companyId).map(cu=>{
            if (!this.existingUsers.includes(cu.user.id) && !tempProjectUsersIds.includes(cu.user.id)) {
                this.companyUsers.push(cu);
            }
        });

        // sort by name
        this.projectUsers = _.sortBy(this.projectUsers,(pu=>pu.user.name));
        this.companyUsers = _.sortBy(this.companyUsers,(cu=>cu.user.name));
    }

    canSubmit = () => this.state.selected && this.state.selected.length > 0

    onUserClick = (userId) => {
        const newSelected = this.state.selected.slice();
        const existingKey = _.findIndex(newSelected, obj => obj.userId === userId);

        if (existingKey !== -1) {
            newSelected.splice(existingKey,1);
        } else {
            newSelected.push({
                userId: userId,
                role: gd.const.meeting.role.PARTICIPANT
            })
        }

        this.setState({
            selected: newSelected
        });
    }

    onSubmit() {
        this.props.params.onSubmit.call(this.props.params.this,this.state.selected);
    }

    onClickSubmit = (e) => {
        e.stopPropagation();
        this.onSubmit();
    }

    onSearchCancel = () => {
        this.setState({search: ''})
    }

    onSearchChange = (event) => {
        this.setState({search: event.target.value ? event.target.value : ''})
    }

    onRoleSelect = (userId, role) => {
        const selected = this.state.selected;

        selected.map(item=>{
            if (item.userId === userId) item.role = role;
        });

        this.setState({
            selected: selected
        });
    }

    render() {
        return <ModalAddUserMeetingUsersForm search={this.state.search}
                                             companyUsers={this.companyUsers}
                                             projectUsers={this.projectUsers}
                                             selected={this.state.selected}
                                             canSubmit={this.canSubmit()}
                                             onClickSubmit={this.onClickSubmit}
                                             onUserClick={this.onUserClick}
                                             onRoleSelect={this.onRoleSelect}
                                             onSearchChange={this.onSearchChange}
                                             onSearchCancel={this.onSearchCancel}
                                             closeModal={this.closeModal}/>
    }
}

module.exports = ModalAddMeetingUser;